<template>
  <div class="table-wrapper" id="reportTable">
    <div class="report-level-wrapper">
      <div class="toggle-label">
        Report Level
      </div>
      <vs-switch v-model="detailReportLevel">
        <template #on>
          Detailed
        </template>
        <template #off>
          Management
        </template>
      </vs-switch>
    </div>
    <v-simple-table
        fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left fixed">
            <div class="header-item-wrapper">
              <span class="header-label">
                Lot
              </span>
              <span class="header-sort" :class="sortBy==='lot'?'active':''" v-on:click="changeSortByToLot"
              >
                <font-awesome-icon icon="sort-down" v-if="sortBy==='lot'"/>
                <font-awesome-icon icon="sort" v-if="sortBy==='closingDate'"/>
              </span>
            </div>
          </th>
          <th class="text-left fixed">
            <div class="header-item-wrapper">
              <span class="header-label">
                Buyer Closing Date
              </span>
              <span class="header-sort" :class="sortBy==='closingDate'?'active':''"
                    v-on:click="changeSortByToClosingDate">
                <font-awesome-icon icon="sort-down" v-if="sortBy==='closingDate'"/>
                <font-awesome-icon icon="sort" v-if="sortBy==='lot'"/>
              </span>
            </div>
          </th>
          <th class="text-left fixed">
            <div class="header-item-wrapper">
              <span class="header-label">Buffer</span>

              <div class="status-checkboxes">
                <vs-tooltip>
                  <vs-checkbox class="checkbox-due"
                               val="due"
                               v-model="options" color="#ffd166">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Due Today
                    </div>
                  </template>
                </vs-tooltip>
                <vs-tooltip>
                  <vs-checkbox class="checkbox-pastdue"
                               val="pastdue"
                               v-model="options" color="#ef476f">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Past due
                    </div>
                  </template>
                </vs-tooltip>
                <vs-tooltip>
                  <vs-checkbox class="checkbox-safe"
                               val="safe"
                               v-model="options" color="#06d6a0">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Not due
                    </div>
                  </template>
                </vs-tooltip>
              </div>
            </div>
          </th>

          <th class="text-left task-label" v-for="(allTaskLabel, index) in allTaskLabels" :key="'label_'+index">
            {{allTaskLabel}}
          </th>
        </tr>
        </thead>
        <tbody>
          <tr class="table-body-row" v-for="(unit,i) in unitsData" :key="i">
            <td class="table-body-item fixed">
              {{ unit.Name }}
            </td>
            <td class="table-body-item fixed">
              {{ formatDate(unit['Buyer Closing Date']) }}
            </td>
            <td class="table-body-item fixed" :class="getDaysToClosingClassByColor(getBufferByUnitID(unit['ID']))">
              <div class="daystoclosing-wrapper">
                <div class="daystoclosing-cell">
                  {{ getBufferByUnitID(unit['ID']) }}
                </div>
              </div>
            </td>
            <th class="text-left task-cell" v-for="(allTaskLabel, index) in allTaskLabels" :key="'content_'+index" @click="clickTaskByUnitIDAndTaskLabel(unit,allTaskLabel)">
              <div class="task-detail-wrapper" v-html="getTaskEndDateByUnitIDAndTaskLabel(unit.ID,allTaskLabel)"></div>
            </th>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="loader" v-if="!unitsData.length">
      <img class="loader-img" alt="Loading" src="@/assets/loading.svg">
    </div>
    <vs-dialog width="300px" not-center v-model="changeDateActive">
        <template #header>
          <h2 class="not-margin">
            Set End Date
          </h2>
          <h4 class="not-margin">
            <b>{{changeDateUnit_taskName}}</b> - {{changeDateUnit_lot}}
          </h4>
        </template>
        <div class="con-content">
          <v-date-picker
          v-model="picker"
          full-width
          color="main-color"
          header-color="main-color"
          ></v-date-picker>
          <v-select
              dense
              :items="statuses"
              v-model="status_value"
              label="Status"
              solo
          ></v-select>
        </div>

        <template #footer>
          <div class="con-footer">
            <vs-button @click="submitTaskScheduleUpdate" color="#f15a35">
              Ok
            </vs-button>
            <vs-button @click="changeDateActive=false" dark >
              Cancel
            </vs-button>
          </div>
        </template>
      </vs-dialog>
  </div>
</template>

<script>

// import vueCustomScrollbar from 'vue-custom-scrollbar'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'UnitsTable',
  props: {
    units: Array
  },
  mounted() {
    // console.log('units', this.units)
    this.getAllUnitsTasks()

  },

  data: function () {
    return {
      status_value: '',
      changeDateActive: false,
      changeDateUnit_lot: '',
      changeDateUnit_taskName: '',
      changeDateUnit_taskID: '',
      changeDateUnit_ID: '',
      input1: '',
      detailReportLevel: true,
      picker: new Date().toISOString().substr(0, 10),
      search: '',
      loading: null,
      progress: 0,
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      unit_tasks: [],
      unit_tasks_labels: [],
      options: [
        'due',
        'pastdue',
        'safe'
      ],
      sortBy: 'closingDate'
    };
  },
  watch: {
    options: function (options) {
      console.log('options:', options)
    },
    detailReportLevel: function (detailReportLevel) {
      console.log('watch detailReportLevel',detailReportLevel)
      this.getAllUnitsTasks();
    }
  },
  components: {
    // vueCustomScrollbar,
  },
  computed: {
    authToken: function () {
      return this.$store.getters.authToken
    },
    statuses: function(){
        let statuses_original = this.$store.getters.statuses.map(item => item['status'])
        statuses_original.push('Do Not Change')
        return statuses_original
    },
    allTaskLabels: function (){
      const _this = this
      let tempAllTaskLabels = []
      _this.unit_tasks.forEach(unit =>
          tempAllTaskLabels = tempAllTaskLabels.concat(unit.unitSchedule)
      )
      // console.log('tempAllTaskLabels',tempAllTaskLabels)
      tempAllTaskLabels.sort((a,b) => Date.parse(a['Start Date'].replace(' Mon','').replace(' Tue','').replace(' Wed','').replace(' Thu','').replace(' Fri','').replace(' Sat','').replace(' Sun','')) - Date.parse(b['Start Date'].replace(' Mon','').replace(' Tue','').replace(' Wed','').replace(' Thu','').replace(' Fri','').replace(' Sat','').replace(' Sun','')))
      // console.log('tempAllTaskLabels',tempAllTaskLabels)

      let tempAllLabels = tempAllTaskLabels.map(item => item['Schedule Live Task'])
      // console.log('tempAllLabels',tempAllLabels)
      let uniqAllLabels = [...new Set(tempAllLabels)]
      // console.log('uniqAllLabels',uniqAllLabels)
      return uniqAllLabels
    },
    unitsData: function () {
      let _this = this;
      let unitsData = this.units
      if (_this.sortBy === 'closingDate') {

        unitsData.sort(function (a, b) {
          let keyA = moment(a['Buyer Closing Date']),
              keyB = moment(b['Buyer Closing Date']);
          // Compare the 2 dates
          // console.log('keyA', keyA, 'keyB', keyB)
          if (keyA.isBefore(keyB)) {
            return -1;
          }
          if (keyA.isAfter(keyB)) {
            return 1;
          }
          return 0;
        });
      } else if (_this.sortBy === 'lot') {
        unitsData.sort(function (a, b) {
          let keyA = a.Name,
              keyB = b.Name;
          // Compare the 2 dates
          // console.log('keyA', keyA, 'keyB', keyB)
          if (keyA < keyB) {
            return -1;
          }
          if (keyA > keyB) {
            return 1;
          }
          return 0;
        });
      }


      return unitsData.filter(function (e) {
        // console.log('e:', e)
        let matchStatusOptions = true
        let matchStatusCode = ''
        let buffer = _this.getBufferByUnitID(e['ID'])
        // let datsToClosing = moment(_this.formatDate(e['Buyer Closing Date'])).diff(moment(),'days')
        if (parseInt(buffer) === 0) {
          matchStatusCode = 'due'
          matchStatusOptions = !!_this.options.includes(matchStatusCode);
        } else if (parseInt(buffer) > 0) {
          matchStatusCode = 'safe'
          matchStatusOptions = !!_this.options.includes(matchStatusCode);
        } else if (parseInt(buffer) < 0) {
          matchStatusCode = 'pastdue'
          matchStatusOptions = !!_this.options.includes(matchStatusCode);
        }
        return (matchStatusOptions)

      });
    }

  },
  methods: {
    getBufferByUnitID(unitID){
      const _this = this
      let foundSchedules = ''
      foundSchedules = JSON.parse(JSON.stringify(_this.unit_tasks)).find(unitSchedule => {
        return unitSchedule.unitID === unitID
      })
      if(foundSchedules){
        console.log('unitID',unitID,foundSchedules.unitBuffer)
        return foundSchedules.unitBuffer || 'N/A'

      }
      else{
        console.log('unitID',unitID,'no foundschedule')
        return 0
      }

    },
    submitTaskScheduleUpdate(){

      const _this = this
      let endDate = _this.picker

      let status = _this.status_value === 'Do Not Change' ? '' : _this.status_value
      axios({
          url: 'https://admin.giraffapp.com/giraffweb_unit_schedule_update?authToken=' + _this.authToken+'&taskID='+_this.changeDateUnit_taskID+'&endDate='+endDate+'&status='+status,
          method: 'GET'
        }).then(resp => {
          if (resp.data.result) {
            console.log('resp.data.result',resp.data.result)
            _this.changeDateActive=false
            _this.$vs.notification({
              duration:'4000',
              color: 'primary',
              progress: 'auto',
              title: 'Success',
              text: `Unit schedule updated, reloading the report now.`
            })
            // this.getAllUnitsTasks()
            this.getUnitTasks(_this.changeDateUnit_ID)
          } else {
            console.log('err')
            _this.$vs.notification({
              duration:'4000',
              color: 'danger',
              progress: 'auto',
              title: 'Error',
              text: `Failed to update unit schedule, please try again later.`
            })
          }
        }).catch(err => {
          console.log('err',err)
        })
    },
    openLoading() {
      const _this = this
      _this.loading = _this.$vs.loading({
        progress: 0,
        text: 'Loading task schedules...',
        color: '#f15a35',
        type: 'scale',
        scale: 2
      })
      // const interval = setInterval(() => {
      //   if (_this.progress <= 100) {
      //     _this.loading.changeProgress(_this.progress++)
      //   }
      // }, 40)

    },
    closeLoading(){
      const _this = this

      setTimeout(() => {
        _this.loading.close()
      }, 1000)
      setTimeout(() => {
        _this.progress = 0
      }, 1500)
    },
    getTaskEndDateByUnitIDAndTaskLabel: function(unitID,taskLabel){
      const _this = this

      let foundSchedules = JSON.parse(JSON.stringify(_this.unit_tasks)).find(unitSchedule => {
        return unitSchedule.unitID === unitID
      })
      // console.log('foundSchedules',foundSchedules)
      if(foundSchedules){

        let foundSchedules_task = foundSchedules.unitSchedule.find(unit_task => {
          return unit_task['Schedule Live Task'] === taskLabel
        })

        if(foundSchedules_task){
          let taskEndDate = foundSchedules_task['End Date'] || foundSchedules_task['Start Date']
          taskEndDate = taskEndDate.replace(/\s*\(.*?\)\s*/g, '')
          let taskEndDateStatus = ''
          let todayMoment = moment()

          let formattedDateMoment = moment(_this.formatDate(taskEndDate))


          let diff = todayMoment.diff(formattedDateMoment, 'days')


          if (diff < 0) {
            taskEndDateStatus = 'not-due'
          } else if (diff > 0) {
            taskEndDateStatus = 'past'
          } else {
            taskEndDateStatus = 'due'
          }
          return "<div class='task-inner-wrapper task-status-"+_this.slugify(foundSchedules_task['Status'])+" task-date-status-"+taskEndDateStatus+" '><div class='task-status'>"+foundSchedules_task['Status'].charAt(0)+"</div><div class='task-date'>"+taskEndDate+"</div></div>"
        }
        else{
          return ''
        }
      }
    },
    clickTaskByUnitIDAndTaskLabel: function(unit,taskLabel){
      const _this = this
      let unitID = unit.ID
      console.log('unit',unit)
      let foundSchedules = JSON.parse(JSON.stringify(_this.unit_tasks)).find(unitSchedule => {
        return unitSchedule.unitID === unitID
      })
      console.log('foundSchedules',foundSchedules)
      if(foundSchedules){

        let foundSchedules_task = foundSchedules.unitSchedule.find(unit_task => {
          return unit_task['Schedule Live Task'] === taskLabel
        })
        if(foundSchedules_task){
          let taskID = foundSchedules_task['ID'] || null
          let taskName = foundSchedules_task['Schedule Live Task'] || null
          let taskStatus = foundSchedules_task['Status']
          if(taskStatus !== 'Complete'){
            if(taskID){
              console.log('click taskID',taskID)
              _this.changeDateActive = true
              _this.changeDateUnit_taskName = taskName
              _this.changeDateUnit_taskID = taskID
              _this.changeDateUnit_ID = unit.ID
              _this.changeDateUnit_lot = unit.Name


            }
            else{
              console.log('click taskID no ID',taskID)
            }
          }

        }
        else{
            console.log('click taskID no ID')
        }
      }
    },
    async getAllUnitsTasks () {
      const _this = this
      let temp_unit_tasks = []
      let totalUnits=_this.units.length
      let finishedUnits = 0

      console.log('detailReportLevel',_this.detailReportLevel)
      _this.openLoading()
      for (let unit of _this.units) {
        await axios({
          url: 'https://admin.giraffapp.com/giraffweb_get_unit_tasks?authToken=' + this.authToken+'&unitID='+unit.ID,
          method: 'GET'
        }).then(resp => {
          if (resp.data.result) {
            const unitsData = resp.data
            let unitSchedule = unitsData.details.unitSchedule
            let unitBuffer = unitsData.details.buffer
            if(unitSchedule){

              if(_this.detailReportLevel){

                var tempObj = {unitID:unit.ID, unitSchedule:unitSchedule,unitBuffer: unitBuffer}
                temp_unit_tasks.push(tempObj)
                finishedUnits ++
                _this.loading.changeProgress(finishedUnits/(totalUnits-1)*100)
                console.log('finishedUnits',finishedUnits,'totalUnits',totalUnits)
                if(finishedUnits === totalUnits){
                  _this.closeLoading()
                }
              }else{
                let filteredUnitSchedule = unitSchedule.filter( x =>
                  x['Report Level'] == ""
                );
                var tempObj2 = {unitID:unit.ID, unitSchedule:filteredUnitSchedule,unitBuffer: unitBuffer}
                temp_unit_tasks.push(tempObj2)
                finishedUnits ++
                _this.loading.changeProgress(finishedUnits/(totalUnits-1)*100)
                console.log('finishedUnits',finishedUnits,'totalUnits',totalUnits)
                if(finishedUnits === totalUnits){
                  _this.closeLoading()
                }
              }

            }
          } else {
            console.log('err')
          }
        }).catch(err => {
          console.log('err',err)
        })
      }
      _this.unit_tasks = temp_unit_tasks
    },
    async getUnitTasks (unitID) {
      const _this = this
      let temp_unit_tasks = []

      console.log('detailReportLevel',_this.detailReportLevel)
      _this.openLoading()
      await axios({
        url: 'https://admin.giraffapp.com/giraffweb_get_unit_tasks?authToken=' + this.authToken+'&unitID='+unitID,
        method: 'GET'
      }).then(resp => {
        if (resp.data.result) {
          const unitsData = resp.data
          let unitSchedule = unitsData.details.unitSchedule
          let unitBuffer = unitsData.details.buffer
          if(unitSchedule){

            if(_this.detailReportLevel){

              var tempObj = {unitID:unitID, unitSchedule:unitSchedule,unitBuffer: unitBuffer}
              temp_unit_tasks.push(tempObj)
              _this.loading.changeProgress(100)
              _this.closeLoading()
            }else{
              let filteredUnitSchedule = unitSchedule.filter( x =>
                  x['Report Level'] === ""
              );
              var tempObj2 = {unitID:unitID, unitSchedule:filteredUnitSchedule,unitBuffer: unitBuffer}
              temp_unit_tasks.push(tempObj2)
              _this.loading.changeProgress(100)
              _this.closeLoading()
            }

          }
        } else {
          console.log('err')
        }
      }).catch(err => {
        console.log('err',err)
      })
      // _this.unit_tasks = temp_unit_tasks
      console.log('temp_unit_tasks',temp_unit_tasks,'_this.unit_tasks',_this.unit_tasks)
      _this.unit_tasks = _this.unit_tasks.map(function(item) { return item.unitID === temp_unit_tasks[0].unitID ? temp_unit_tasks[0] : item; });


    },

    getDaysToClosingClassByColor: function (buffer) {
      if (parseInt(buffer) === 0) {
        return 'daystoclosing-today';
      } else if (buffer > 0) {
        return 'daystoclosing-above';
      } else if (buffer < 0) {
        return 'daystoclosing-below';
      } else {
        return 'daystoclosing-default';
      }
    },

    clickTask() {
      console.log('clicked task')
    },

    getBorderColorOfDate(date) {
      let todayMoment = moment()
      let formattedDate = this.formatDate(date)
      if (formattedDate) {
        let formattedDateMoment = moment(formattedDate)

        let diff = todayMoment.diff(formattedDateMoment, 'days')
        if (diff < 0) {
          return "#06d6a0"
        } else if (diff > 0) {
          return "#ef476f"
        } else {
          return "#ffd166"
        }

      } else {
        return "#000000"
      }
    },
    formatDate(originalDate) {
      let formattedDate = '';
      if (originalDate) {
        let trimmedOriginalDate = originalDate.replace('Mon', '').replace('Tue', '').replace('Wed', '').replace('Thu', '').replace('Fri', '').replace('Sat', '').replace('Sun', '')
        if(trimmedOriginalDate.includes("(")){
            trimmedOriginalDate = trimmedOriginalDate.split('(')[0]
        }
        formattedDate = moment(trimmedOriginalDate).format('MMM DD, YYYY');
      }
      return formattedDate;
    },
    changeSortByToLot() {
      this.sortBy = 'lot'
    },
    changeSortByToClosingDate() {
      this.sortBy = 'closingDate'
    },
    slugify(string){
      return string
          .toString()
          .normalize('NFD')                   // split an accented letter in the base letter and the acent
          .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
          .replace(/\s+/g, "-");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
.report-level-wrapper
  margin: 1em 0
  display: flex
  flex-direction: row
  align-items: center
  justify-content: flex-start
  text-align: left
  .toggle-label
    margin-right: 1em
.table-wrapper#reportTable

  .search
    padding: 0em 0 0em
    +mobile
      padding: 0em 0 0em

    .vs-input
      background-color: rgba(gray, 0.01)

      border: 1px solid rgba(black,0.05)
      border-radius: 0px
      color: black

    .vs-input__label.vs-input__label--label
      font-size: 1.2em
      margin-bottom: 0.5em
  .v-data-table__wrapper
    max-height: calc(100vh - 12em)
    table
      table-layout: fixed
      +mobile
        table-layout: auto
  .table
    width: 100%
    border-collapse: collapse

  thead
    background-color: rgba(gray, 0.1)
    border-width: 0 1px 0 1px
    padding: 0.5em 0
    tr
      border-bottom: 2px solid black
      th
        font-weight: bold
        font-size: 1em !important
        color: black !important
        text-align: left
        padding: 0.5em
        z-index: 1
        +mobile
          font-size: 0.85em !important
          white-space: nowrap
        &.fixed
          position: sticky
          left: 0
          z-index: 3
          width: 150px
          background-color: white
          +mobile
            position: relative
            width: auto
            left: auto
          &:nth-child(2)
            left: 150px
            +mobile
              left: auto
          &:nth-child(3)
            left: 300px
            width: 70px
            border-right: 1px solid rgba(black,0.3)
            +mobile
              border-right: none
              left: auto
        &.task-label
          border: 1px solid rgba(black, 0.1)
          text-align: center !important
          font-weight: 900
          text-transform: capitalize
          font-size: 0.85em !important
          min-width: 100px
          width: 150px
        .header-item-wrapper
          display: block
          flex-direction: row
          align-items: center

          .header-sort
            cursor: pointer
            opacity: 0.5

            &.active
              opacity: 1
              pointer-events: none

          svg
            margin: 0 0.25em

          .status-checkboxes
            display: flex
            display: none
            flex-direction: row
            margin-top: 0.5em

            .vs-checkbox-content
              margin-right: 0.5em

              &.checkbox-due
                .vs-checkbox-mask:before
                  background-color: $Neutral
                  opacity: 0.8

              &.checkbox-pastdue
                .vs-checkbox-mask:before
                  background-color: $Warning
                  opacity: 0.8

              &.checkbox-safe
                .vs-checkbox-mask:before
                  background-color: $Safe
                  opacity: 0.8

  tbody

    width: 100%
    border-collapse: collapse
    .table-body-row
      flex-direction: row
      border: 1px solid rgba(black, 0.1)
      border-width: 1px 0 0 0
      align-items: center
      border-collapse: collapse
    .task-cell
      border: 0.5px solid rgba(black, 0.1)
      border-collapse: collapse
      padding: 0
      height: 100%

      .task-detail-wrapper
        text-align: center
        height: 100%
        display: block
        .task-date
          white-space: normal
        .task-inner-wrapper
          padding: 1.2em
          cursor: pointer
          &:hover
            background-color: black
            color: white !important
          &.task-status-complete
            cursor: not-allowed
            pointer-events: none
            background-color: #a1a1a1
            .task-status
              color: black !important
            .task-date
              color: black !important
          &.task-status-schedule-work-order
            .task-date
              border-bottom: 2px solid $Warning
          &.task-status-in-progress
            .task-date
              border-bottom: 2px solid $Safe
          &.task-status-new
            .task-status
              color: $Neutral
          &.task-status-complete-do-not-pay
            .task-status
              color: $Blue
            .task-date
              color: $Blue !important
          &.task-date-status-past
            .task-date
              color: $Warning
          &.task-date-status-due
            .task-date
              color: $Neutral
          &.task-date-status-not-due
            .task-date
              color: $Safe

        .task-status
          font-weight: 800
          font-size: 1.5em
          display: none
          +mobile
            font-size: 1em


    .table-body-item
      font-size: 1em
      font-weight: 500
      border: 1px solid rgba(black,0.1)
      padding: 0.5em
      text-align: left
      white-space: nowrap
      z-index: 1
      +mobile
        font-size: 0.85em !important
      &.fixed
        position: sticky
        left: 0px
        z-index: 2
        width: 150px
        background-color: white


        +mobile
          position: relative
          width: auto
          left: auto
        &:nth-child(2)
          left: 150px
          +mobile
            left: auto
        &:nth-child(3)
          left: 300px
          border-right: 2px solid rgba(black,0.3)
          +mobile
            border-right: none
            left: auto
      .start-date-button,.end-date-button
        white-space: nowrap
      .body-item-wrapper
        display: flex
        flex-direction: row
        align-items: center

        .task-name-button
          max-width: 300px
          min-width: 200px

          .vs-button__content
            padding-left: 1em
            padding-right: 1em

        .extra-indicator
          padding: 0.1em 0.5em
          border-radius: 12px
          background-color: $Main
          color: white
          z-index: 1
          cursor: help



      &[class*=daystoclosing-]
        .daystoclosing-wrapper
          display: flex
          flex-direction: column
          text-align: center
          justify-content: center
          align-items: center
          border-radius: 12px

          color: white
          width: 2.5em
          height: 2.5em

          .daystoclosing-cell
            font-weight: bold
            padding-top: 0.1em
        padding: 0
        .daystoclosing-wrapper
          border-radius: 0

        &.daystoclosing-today
          .daystoclosing-wrapper
            color: $Neutral

        &.daystoclosing-above
          .daystoclosing-wrapper
            color: $Safe

        &.daystoclosing-below
          .daystoclosing-wrapper
            color: $Warning

      .vs-button__content
        font-weight: bold
        color: white

  .con-footer
    display: flex
    align-items: center
    justify-content: flex-end
    .vs-button
      margin: 0px
      .vs-button__content
        padding: 10px 30px
      ~ .vs-button
        margin-left: 10px
  .not-margin
    margin: 0px
    font-weight: normal
    padding: 10px
    padding-bottom: 0px
  .con-content
    width: 100%
    p
      font-size: .8rem
      padding: 0px 10px
    .vs-checkbox-label
      font-size: .8rem
    .vs-input-parent
      width: 100%
    .vs-input-content
      margin: 10px 0px
      width: calc(100%)
      .vs-input
        width: 100%
  .footer-dialog
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    width: calc(100%)


.loader
  margin: 2em

  img
    width: 60px
    height: 60px


.list-enter-active, .list-leave-active
  transition: all 0.3s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateX(-10px)
</style>
